import { gql, useMutation } from "@apollo/client";

import { UpdateAssetInput } from "../../../generated/gql/graphql";

const UPDATE_ASSET = gql`
  mutation UpdateAsset($updateAssetId: String!, $input: UpdateAssetInput!) {
    updateAsset(id: $updateAssetId, input: $input) {
      id
      approval
      status
      sort
      type
      name
      image
      parentId
      categoryId
      nextAssetId
      prevAssetId
      contentAmount
      contentUnit
      favorite
      geometry
      metashotsType
      languageRegionsId
      assetTypes
      brandId
      collectionId
      oderIndex
      dateCreated
      dateUpdated
      projectId
      masterId
      adaptionId
    }
  }
`;

type UpdateAssetApi = {
  updateAsset(id: string, input: UpdateAssetInput): Promise<unknown>;
};

export default function useUpdateAsset(): UpdateAssetApi {
  const [updateAssetMut] = useMutation<UpdateAssetInput>(UPDATE_ASSET);

  async function updateAsset(
    id: string,
    input: UpdateAssetInput
  ): Promise<unknown> {
    if (!id) {
      throw new Error("Id is required");
    }

    return await updateAssetMut({
      context: {
        headers: {
          "apollo-require-preflight": true,
        },
      },
      variables: {
        updateAssetId: id,
        input,
      },
    });
  }

  return {
    updateAsset,
  };
}
